var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Row, Col, Form, Typography, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Input, Button } from 'ui/styled';
import { StyledButton } from 'ui/styled/Buttons';
import MemberFields from './MemberFields';
var Item = Form.Item;
var Text = Typography.Text;
var MemberAdditionSection = function (_a) {
    var _b = _a.isTicketContext, isTicketContext = _b === void 0 ? false : _b;
    var _c = useState(false), draftVisible = _c[0], setDraftVisible = _c[1];
    var draftForm = Form.useForm()[0];
    return (_jsxs(_Fragment, { children: [_jsx(Row, { style: { marginTop: 24, marginBottom: 16 }, children: _jsx(Col, { span: 24, children: _jsx(Text, { strong: true, style: { fontSize: 16 }, children: "Manual Member Add" }) }) }), _jsx(Form.List, { name: "eligibility_inquiry_members_attributes", children: function (fields, _a) {
                    var add = _a.add, remove = _a.remove;
                    return (_jsxs(_Fragment, { children: [fields.map(function (_a, index) {
                                var key = _a.key, name = _a.name, restField = __rest(_a, ["key", "name"]);
                                return (_jsxs("div", { style: {
                                        marginBottom: 24,
                                        padding: 16,
                                        border: '1px solid #d9d9d9',
                                        borderRadius: 6,
                                        position: 'relative'
                                    }, children: [_jsxs(Space, { align: "center", style: { width: '100%', justifyContent: 'space-between' }, children: [_jsxs(Text, { strong: true, children: ["Member ", index + 1] }), _jsx(StyledButton, { onClick: function () { return remove(name); }, children: "Remove" })] }), _jsx(Item, __assign({}, restField, { name: [name, 'id'], hidden: true, children: _jsx(Input, {}) })), _jsx(MemberFields, { prefix: [name] })] }, key));
                            }), isTicketContext && draftVisible && (_jsxs("div", { style: {
                                    marginBottom: 24,
                                    padding: 16,
                                    border: '2px dashed #91d5ff',
                                    borderRadius: 6
                                }, children: [_jsx(Text, { strong: true, style: { display: 'block', marginBottom: 16 }, children: "New Member" }), _jsxs(Form, { form: draftForm, children: [_jsx("div", { style: { marginTop: 8 }, children: _jsx(MemberFields, {}) }), _jsxs(Space, { style: { marginTop: 16 }, children: [_jsx(Button, { type: "primary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                            var values, _a;
                                                            return __generator(this, function (_b) {
                                                                switch (_b.label) {
                                                                    case 0:
                                                                        _b.trys.push([0, 2, , 3]);
                                                                        return [4 /*yield*/, draftForm.validateFields()];
                                                                    case 1:
                                                                        values = _b.sent();
                                                                        add(values);
                                                                        draftForm.resetFields();
                                                                        setDraftVisible(false);
                                                                        return [3 /*break*/, 3];
                                                                    case 2:
                                                                        _a = _b.sent();
                                                                        return [3 /*break*/, 3];
                                                                    case 3: return [2 /*return*/];
                                                                }
                                                            });
                                                        }); }, children: "Save Member" }), _jsx(Button, { onClick: function () { return setDraftVisible(false); }, children: "Cancel" })] })] })] })), !draftVisible && (_jsx(Form.Item, { children: _jsx(Button, { type: "dashed", block: true, onClick: function () {
                                        if (isTicketContext) {
                                            setDraftVisible(true);
                                        }
                                        else {
                                            add();
                                        }
                                    }, icon: _jsx(PlusOutlined, {}), disabled: fields.length >= 3, children: "Add Member" }) }))] }));
                } })] }));
};
export default MemberAdditionSection;
